import React from 'react';
import PropTypes from 'prop-types';
import { BodyMedium, LinkSmall, LinkText } from '@styled';
import { formatMoney } from '@general/helpers/currency.helpers';

const CartSummaryDiscountCredit = ({ amountAvailable, amountUsed, creditType, hideUndo, locale, onApply, onUndo }) => {
    return (
        <div>
            <div className="flex justify-between mb-0.5rem">
                <BodyMedium>Available {creditType} Credit</BodyMedium>
                <BodyMedium>{formatMoney(amountAvailable, locale)}</BodyMedium>
            </div>

            <div className="text-right">
                {amountAvailable > 0 && amountUsed === 0 && (
                    <LinkSmall
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            onApply();
                        }}
                    >
                        <u>Apply Credit</u>
                    </LinkSmall>
                )}

                {amountUsed > 0 && !hideUndo && (
                    <LinkText>
                        <i>Credit Applied</i>
                        <LinkSmall
                            href="#"
                            className="ml-0.5rem"
                            onClick={e => {
                                e.preventDefault();
                                onUndo();
                            }}
                        >
                            <u>Undo</u>
                        </LinkSmall>
                    </LinkText>
                )}
            </div>
        </div>
    );
};

CartSummaryDiscountCredit.propTypes = {
    amountAvailable: PropTypes.number.isRequired,
    amountUsed: PropTypes.number.isRequired,
    creditType: PropTypes.oneOf(['Store', 'Event']).isRequired,
    hideUndo: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    onApply: PropTypes.func.isRequired,
    onUndo: PropTypes.func,
};

export default CartSummaryDiscountCredit;
